import evaluationPromptTemplate from './prompts/evaluation-prompt.md?raw';

export const evaluationPrompt = (optimizationId: string) =>
    evaluationPromptTemplate.replaceAll('{{optimizationId}}', optimizationId);
